import * as _ from 'underscore';

import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { DatasourceContentType } from '../models/ContentTypes';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../../content/resources/Datasources';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { ContentUrlForItem } from './ContentUrl';
import { Messages } from '../../codegen/Localize';
import { openReactAlertDialog } from '../../commonInfra/dialogs/ReactAlertDialog';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import {
  standardActionErrorMsg,
  standardActionSuccessMsg, StandardActionToastMessages
} from '../../commonInfra/contentActions/ActionHelpers';

export class ChangeDatasourcesTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsDatasourcesSuccess),
    error: standardActionErrorMsg(Messages.changeTagsDatasourcesError),
  };

  public execute: (itemSet: Set<IDataSourceBase>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService','$translate', 'ModalService'];

  constructor(
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
  ) {
    this.execute = ChangeTagsActionHelper.createExecuteFn<IDataSourceBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => DataSources.changeTags(ids, addTags, removeTags),
      getDescription: (datasources: Set<IDataSourceBase>) => this.getDescription(datasources),
      notificationFns: ChangeDatasourcesTagsAction.notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<IDataSourceBase>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(datasources: Set<IDataSourceBase>) {
    return (datasources.size() === 1)
      ? this.$translate.instant('changeTagsDatasourceDescription', { NAME: L10n.elideIfLong(datasources.first().name) })
      : this.$translate.instant('changeTagsDatasourcesDescription', { COUNT: datasources.size() }, L10n.Interpolations.Count);
  }

  public showChangeTagsDialog(datasources: Set<IDataSourceBase>,
                              actionContext: IActionContext): ng.IPromise<IResult> {

    // Disallow changing tags if all selected datasources are embedded.
    if (datasources.all((ds: IDataSourceBase) => _.isObject(ds.workbook))) {
      return openReactAlertDialog({
        title: Messages.changeTagsDatasource_cannotTagAlertTitle(),
        message: Messages.changeTagsDatasource_cannotTagAlertMessage()
      }).result;
    }

    return this.execute(datasources, actionContext);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, DatasourceContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeDatasourcesTagsAction', ChangeDatasourcesTagsAction);
